// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading___2C8lp"};